/** 將 Date 轉 yyyy-MM-dd */
export function formatDateInput(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function parseDateInput(value) {
  if (!value) return null;
  const [y, m, d] = value.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/** 取得某週的週一（本地時區） */
function startOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
}

export const QUICK_RANGE_KEYS = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  DAY_BEFORE: 'dayBefore',
  THIS_WEEK: 'thisWeek',
  LAST_WEEK: 'lastWeek',
  THIS_MONTH: 'thisMonth',
};

export function resolveQuickRange(key) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  switch (key) {
    case QUICK_RANGE_KEYS.TODAY:
      return { start: today, end: today };
    case QUICK_RANGE_KEYS.YESTERDAY: {
      const d = new Date(today);
      d.setDate(d.getDate() - 1);
      return { start: d, end: d };
    }
    case QUICK_RANGE_KEYS.DAY_BEFORE: {
      const d = new Date(today);
      d.setDate(d.getDate() - 2);
      return { start: d, end: d };
    }
    case QUICK_RANGE_KEYS.THIS_WEEK: {
      const start = startOfWeek(today);
      return { start, end: today };
    }
    case QUICK_RANGE_KEYS.LAST_WEEK: {
      const thisMonday = startOfWeek(today);
      const lastMonday = new Date(thisMonday);
      lastMonday.setDate(lastMonday.getDate() - 7);
      const lastSunday = new Date(thisMonday);
      lastSunday.setDate(lastSunday.getDate() - 1);
      return { start: lastMonday, end: lastSunday };
    }
    case QUICK_RANGE_KEYS.THIS_MONTH: {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      return { start, end: today };
    }
    default:
      return { start: today, end: today };
  }
}
